import React, { useRef, useEffect } from 'react';
import VanillaTilt from 'vanilla-tilt';
import styles from './LastTransaction.module.scss';

const LastTransaction = ({ title, children }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const isDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    if (cardRef.current && isDesktop) {
      VanillaTilt.init(cardRef.current, {
        max: 10,
        speed: 1000,
        perspective: 1000,
        glare: true,
        'max-glare': 0.1,
        scale: 1,
        reset: true,
      });
    }

    return () => {
      if (cardRef.current && cardRef.current.vanillaTilt) {
        cardRef.current.vanillaTilt.destroy();
      }
    };
  }, []);

  return (
    <div className={styles.stats__block} ref={cardRef}>
      <h4 className={styles.stats__subtitle}>{title}</h4>

      <div className={styles.stats__lastTransaction}>{children}</div>
    </div>
  );
};

export default LastTransaction;